import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Global } from 'projects/shared-lib/src/lib/_constants/global.variables';
import { OktaAuth } from '@okta/okta-auth-js';
import { OKTA_AUTH } from '@okta/okta-angular';
import { SecurityService } from "projects/shared-lib/src/lib/services/security.service";
import { DataService } from "projects/shared-lib/src/lib/services/data.service";


@Component({
	selector: "app-home-component",
	templateUrl: "./home.component.html",
	styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit, OnDestroy {
	public userName: string;
	isAuthenticated: boolean = false;
	
	private componentName: string = "home.component.ts: ";
	private userIsBeingAuthenticated: boolean = false;
	private userIsBeingProcessed: boolean = false;
	constructor(private router: Router,	
				@Inject(OKTA_AUTH) public oktaAuth: OktaAuth, 
				private securityService: SecurityService,
				private dataService: DataService
			) 
	{
		this.securityService.userIsBeingProcessed$.subscribe((processing:boolean) => {
			this.userIsBeingProcessed = processing;
		});

		this.securityService.userIsBeingAuthenticated$.subscribe((authenticating:boolean) => {
			this.userIsBeingAuthenticated = authenticating;
		});
	}

	async ngOnInit() {
		this.dataService.initializeGlobalVariables("desktop");
		if (this.userIsBeingAuthenticated == false && this.userIsBeingProcessed == false && Global.User.isLoggedIn == false) {
			this.securityService.userIsBeingAuthenticated$.next(true);
			this.checkOktaAuthentication().then((data:boolean) => {
				this.isAuthenticated = data;
				if (this.isAuthenticated == true) {
					this.processLoggedInUser();
				}
				else {
					localStorage.clear();
					this.oktaAuth.signInWithRedirect({ originalUri: '/' });
				}
			});
		}

	}				

	
	ngOnDestroy(): void {
		console.log(this.componentName + ": ngOnDestroy invoked...");	
		this.securityService.userIsBeingAuthenticated$.unsubscribe();
		this.securityService.userIsBeingProcessed$.unsubscribe();
	}

	async checkOktaAuthentication() {
		return await this.oktaAuth.isAuthenticated();
	}

	async processLoggedInUser() {
		const userClaims = await this.oktaAuth.getUser();
		const authToken = this.oktaAuth.getAccessToken();
		console.log("user = %O", userClaims);
		console.log("Okta authToken = "+ authToken);
		this.securityService.processLoggedInUser(authToken, userClaims.email); //--this handles the redirecting to the correct route after processing the logged-in user.
	}
}
